import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "../ui/accordion";

import {
  Brain,
  Activity,
  Stethoscope,
  Users,
  Shield,
  Award,
  Clock,
  Phone,
  Mail,
  MapPin,
  Check,
  Calendar,
  ArrowRight,
  Baby,
  Scan,
  Scissors
} from "lucide-react";
import ANUSHA from "../images/DR.ANUSHA.JPG";
import RITHVIC from "../images/DR. RITHVIC.JPG";
import Swapnil from "../images/Dr.SwapnilKolpakwar.png";

export default function NeurosurgeryPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Neurosurgery");



  const subspecialties = [
    {
      title: "Brain Tumor Surgery",
      icon: <Brain className="h-6 w-6 text-apple-teal" />,
      description: "Removal of benign & malignant brain tumors.",
      image: "/BrainTumorSurgery.jpg"
    },
    {
      title: "Spine Surgery",
      icon: <Activity className="h-6 w-6 text-apple-teal" />,
      description:
        "Disc prolapse, spinal fractures, deformities & nerve compression.",
      image: "/SpineSurgery.jpg"
    },
    {
      title: "Neuro-Trauma Care",
      icon: <Shield className="h-6 w-6 text-apple-teal" />,
      description: "Emergency care for head injuries & brain hemorrhage.",
      image: "/Neuro-TraumaCare.jpg"
    },
    {
      title: "Minimally Invasive Neurosurgery",
      icon: <Scissors className="h-6 w-6 text-apple-teal" />,
      description: "Keyhole & endoscopic brain and spine surgeries.",
      image: "/MinimallyInvasiveNeurosurgery.jpg"
    },
    {
      title: "Pediatric Neurosurgery",
      icon: <Baby className="h-6 w-6 text-apple-teal" />,
      description:
        "Treatment of congenital brain & spine disorders in children.",
      image: "/PediatricNeurosurgery.jpg"
    },
    {
      title: "Cerebrovascular Surgery",
      icon: <Scan className="h-6 w-6 text-apple-teal" />,
      description: "Aneurysms, AVMs & stroke-related surgeries.",
      image: "/CerebrovascularSurgery.jpg"
    }
  ];

  const procedures = [
    "Brain Tumor Removal (Open & Endoscopic)",
    "Spine Fusion & Stabilization Surgery",
    "Slip Disc / Disc Prolapse Surgery",
    "Minimally Invasive Spine Surgery",
    "Head Injury & Trauma Surgery",
    "Hydrocephalus & Shunt Procedures",
    "Aneurysm Clipping & Coiling",
    "Chiari Malformation & Skull Base Surgery"
  ];

  const whyChoose = [
    {
      icon: <Activity className="h-8 w-8 text-apple-teal" />,
      title: "Advanced Neuro-ICU",
      description:
        "Continuous monitoring with advanced life support systems for optimal patient care."
    },
    {
      icon: <Users className="h-8 w-8 text-apple-teal" />,
      title: "Experienced Neurosurgeons",
      description:
        "Trained in complex procedures with international expertise and proven success rates."
    },
    {
      icon: <Shield className="h-8 w-8 text-apple-teal" />,
      title: "Minimally Invasive Options",
      description:
        "Keyhole surgical options for faster recovery and reduced complications."
    },
    {
      icon: <Stethoscope className="h-8 w-8 text-apple-teal" />,
      title: "Integrated Rehabilitation",
      description:
        "Comprehensive neuro-rehabilitation & physiotherapy for complete recovery."
    },
    {
      icon: <Clock className="h-8 w-8 text-apple-teal" />,
      title: "24x7 Emergency Response",
      description:
        "Round-the-clock care for trauma & stroke emergencies with immediate intervention."
    }
  ];


  const articles = [
    {
      icon: <Brain className="h-6 w-6 text-apple-teal" />,
      title: "When Should You Consult a Neurosurgeon?",
      description:
        "Learn about symptoms and conditions that require neurosurgical consultation."
    },
    {
      icon: <Activity className="h-6 w-6 text-apple-teal" />,
      title: "Understanding Brain Tumors — Types & Symptoms",
      description: "Comprehensive guide to brain tumor diagnosis & treatment."
    },
    {
      icon: <Scissors className="h-6 w-6 text-apple-teal" />,
      title: "Minimally Invasive Spine Surgery: Benefits & Recovery",
      description: "Explore advanced surgical techniques with faster recovery."
    },
    {
      icon: <Shield className="h-6 w-6 text-apple-teal" />,
      title: "What to Do Immediately After a Head Injury",
      description: "Emergency response guide for head trauma."
    }
  ];

  const faqs = [
    {
      question: "What conditions require neurosurgery?",
      answer:
        "Brain tumors, spine problems, aneurysms, nerve compression, trauma injuries, and congenital neurological issues."
    },
    {
      question: "Are brain and spine surgeries safe?",
      answer:
        "Yes, with modern imaging, navigation systems, and experienced neurosurgeons, surgeries are safer and minimally invasive."
    },
    {
      question: "Do you have a Neuro-ICU?",
      answer:
        "Yes, MAMS Hospitals has a fully equipped Neuro-ICU for post-surgical monitoring and critical care."
    }
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Neurosurgery Department",
    "url": "https://mamshospitals.com/neurosurgery",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Neurosurgery.jpg",
    "description": "MAMS Hospitals provides advanced neurosurgery treatment in Hyderabad including brain tumor surgery, spine surgery, neuro-trauma care, minimally invasive neurosurgery, and stroke-related procedures.",
    "medicalSpecialty": "Neurosurgery",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Brain Tumor Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Spine Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Minimally Invasive Neurosurgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Aneurysm Clipping"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Neuro-Trauma Surgery"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What conditions require neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Brain tumors, spine disorders, aneurysms, trauma injuries, and nerve compression conditions may require neurosurgery."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide minimally invasive neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals offers minimally invasive and endoscopic neurosurgery procedures for faster recovery."
        }
      },
      {
        "@type": "Question",
        "name": "Do you have emergency neuro-trauma care?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides 24x7 neuro-emergency and trauma care services."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Neurosurgery Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/neurosurgery",
    "description": "Best neurosurgery hospital in Hyderabad offering brain tumor surgery, spine surgery, neuro-trauma care, minimally invasive brain surgery, and stroke-related procedures.",
    "keywords": [
      "Neurosurgery Hospital Hyderabad",
      "Best Neurosurgeon Hyderabad",
      "Brain Tumor Surgery Hyderabad",
      "Spine Surgery Hyderabad",
      "Neuro Trauma Care Hyderabad",
      "Brain Surgery Hyderabad",
      "Neuro Hospital Bachupally"
    ]
  }
  ];

  return (
    <>
    <SEO
  title="Best Neurosurgery Hospital in Hyderabad | Brain & Spine Surgery | MAMS Hospitals"
  description="MAMS Hospitals offers advanced neurosurgery treatment in Hyderabad including brain tumor surgery, spine surgery, neuro-trauma care, minimally invasive neurosurgery & 24x7 neuro emergency care."
  keywords="neurosurgery hospital Hyderabad,
  best neurosurgeon Hyderabad,
  brain tumor surgery Hyderabad,
  spine surgery Hyderabad,
  brain surgery Hyderabad,
  neuro trauma care Hyderabad,
  minimally invasive neurosurgery Hyderabad,
  stroke surgery Hyderabad,
  aneurysm surgery Hyderabad,
  neuro ICU Hyderabad,
  brain specialist Hyderabad,
  spine specialist Hyderabad,
  MAMS Hospitals Neurosurgery"
    schema={schema}
  />
    <div className="flex flex-col min-h-screen">

      {/* HERO */}
      <section className="relative bg-gradient-to-b from-apple-teal/10 to-white py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-apple-teal/10 px-4 py-2 rounded-full mb-6">
                <Brain className="h-5 w-5 text-apple-teal" />
                <span className="text-apple-teal font-medium">
                  Best Neurosurgery Hospital in Hyderabad
                </span>
              </div>

              <h1 className="text-3xl md:text-5xl font-bold text-apple-gray-500 mb-6">
                Expert Neurosurgery Care
              </h1>

              <p className="text-lg text-apple-gray-400 mb-8">
                Expert hands for delicate brain & spine surgery — restoring health, function, and quality of life.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>

            <div className="relative mt-8 md:mt-0">
              <img
                src="/Neurosurgery.jpg"
                className="rounded-3xl shadow-2xl w-full"
                alt="Neurosurgery Care"
              canonicalUrl="https://mamshospitals.com/departments/neurosurgery"
      />

              <div className="absolute -bottom-4 left-2 sm:-bottom-6 sm:-left-6 bg-white p-3 sm:p-6 rounded-2xl shadow-lg">
                <div className="flex items-center gap-4">
                  <div className="bg-green-100 p-3 rounded-full">
                    <Brain className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-apple-gray-500">24/7</div>
                    <div className="text-sm text-apple-gray-400">Neuro-Emergency</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SUBSPECIALTIES */}
      <section className="py-16 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Sub-Specialities in Neurosurgery
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Comprehensive neurosurgical care for brain, spine, and nervous system disorders
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((service, i) => (
              <Card
                key={i}
                className="border-apple-gray-100 hover:border-apple-teal transition-all rounded-3xl overflow-hidden"
              >
                <div className="aspect-video bg-apple-gray-50 overflow-hidden">
                  <img
                    src={service.image}
                    className="w-full h-full object-cover"
                  />
                </div>

                <CardContent className="p-6">
                  <div className="bg-apple-teal/10 p-3 rounded-full w-12 h-12 mb-4 flex items-center justify-center">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-apple-gray-400 text-sm">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* PROCEDURES */}
      <section className="py-16 px-0 bg-apple-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Treatments & Procedures
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Advanced neurosurgical interventions performed with precision
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-8">
            {procedures.map((p, i) => (
              <Card key={i} className="rounded-2xl border-apple-gray-100">
                <CardContent className="p-4 flex gap-3 items-center">
                  <div className="bg-apple-teal/10 p-2 rounded-full">
                    <Check className="h-5 w-5 text-apple-teal" />
                  </div>
                  <p className="text-apple-gray-500 font-medium">{p}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card className="rounded-3xl border-apple-teal/30 bg-apple-teal/10">
            <CardContent className="p-8">
              <div className="flex gap-4 items-start">
                <div className="bg-apple-teal/20 p-3 rounded-full">
                  <Activity className="h-6 w-6 text-apple-teal" />
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                    Major Procedures Offered
                  </h3>
                  <p className="text-apple-gray-400">
                    Includes brain tumor surgery, spine surgery, trauma care, & minimally invasive techniques.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-16 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Why Choose MAMS Hospitals for Neurosurgery
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Experience world-class care with advanced technology
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, i) => (
              <Card
                key={i}
                className="border-apple-gray-100 hover:border-apple-teal rounded-3xl transition-all"
              >
                <CardContent className="p-6">
                  <div className="bg-apple-teal/10 p-3 rounded-full w-fit mb-4">
                    {item.icon}
                  </div>

                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                    {item.title}
                  </h3>

                  <p className="text-apple-gray-400">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* EXPERT DOCTOR */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}

      {/* ARTICLES */}
      {/* <section className="py-16 px-0 bg-white">
        <div className="container mx-auto max-w-6xl text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
            Recent Articles
          </h2>
          <p className="text-apple-gray-400 max-w-2xl mx-auto">
            Stay informed about neurosurgery and brain health
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {articles.map((article, i) => (
            <Card
              key={i}
              className="border-apple-gray-100 hover:border-apple-teal transition-all rounded-3xl cursor-pointer"
            >
              <CardContent className="p-6">
                <div className="flex gap-4">
                  <div className="bg-apple-teal/10 p-3 rounded-full">
                    {article.icon}
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-apple-gray-500 mb-2">
                      {article.title}
                    </h3>

                    <p className="text-apple-gray-400 text-sm mb-3">
                      {article.description}
                    </p>

                    <div className="flex items-center text-apple-teal text-sm font-medium">
                      Read more
                      <ArrowRight className="ml-1 h-4 w-4" />
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-apple-gray-400">
            Read more on our{" "}
            <Link to="/blog" className="text-apple-teal hover:underline">
              MAMS Hospitals Blog
            </Link>
          </p>
        </div>
      </section> */}

      {/* FAQ */}
      <section className="py-16 px-0 bg-apple-gray-50">
        <div className="container mx-auto max-w-4xl text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-apple-gray-400">
            Common questions about neurosurgery at MAMS Hospitals
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-apple-gray-100 rounded-2xl px-6 bg-white"
            >
              <AccordionTrigger className="py-4 text-left">
                <span className="font-semibold text-apple-gray-500">
                  {faq.question}
                </span>
              </AccordionTrigger>

              <AccordionContent className="text-apple-gray-400 pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>

    </>
  );
}
